import { useEffect, useState, useRef } from 'react'
import ReactQuill from 'react-quill-new'
import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RotatingLines } from "react-loader-spinner"
import axios from 'axios'
import DivBottom from '../userNotAuth/components/divBottom'

function ConfirmAddEvento() {
    let redux = useSelector((state) => state.creaEvento.value)
    const navigate = useNavigate()
    const grid = { display: 'grid', gridTemplateColumns: '7rem 1fr', gap: '0px' }
    const [msgProgress, setMsgProgress] = useState({ string: null })//barra del loader dopo submit 

    const stringa = useRef('')
    const ospiti = useRef()// array di appoggio per layout degli ospiti

    const email = localStorage.getItem('email')
    let idUtente = localStorage.getItem('idUser')

    const numOspiti = [1, 2, 3, 4, 5]// NUMERO MASSIMO DI OSPITI
    setOspiti()

    function setOspiti() {
        let arrOspiti = []
        numOspiti.forEach(index => {
            const nm = "ospite" + index
            return (
                redux[nm] && arrOspiti.push(redux[nm])
            )
        })
        ospiti.current = arrOspiti
    }
    async function create() {
        if (!idUtente || idUtente === 'null' || idUtente === 'undefined' || idUtente.trim() === '') {
            idUtente = Math.random().toString(36).slice(2, 11)
            localStorage.setItem('idUser', idUtente)
            console.log(localStorage.setItem('idUser', idUtente))
        }
        setMsgProgress({ string: 'Caricamento in corso...', failed: null })
        redux = { ...redux, emailUser: email, userId: idUtente }
        setTimeout(() => {//attendo il caricamento di 'imgName'
            try {
                axios.post(`/createEvento`, redux).then(res => {
                    if (res.data === 'success') {
                        setMsgProgress({ string: null })
                        navigate('/creaEvento', { replace: true })
                    }
                })
            } catch (err) { setMsgProgress({ failed: '*** Problemi con il server...riprova ***', string: null }); console.error(err); return }
        }, 2000)
    }
    useEffect(() => {//SETTAGGIO OPZIONI EVENTO
        if (redux.opzioniEvento.length !== 0) {
            redux.opzioniEvento.forEach((elem, index) => {
                switch (elem) {
                    case "artisti": stringa.current += 'Artisti di strada, '; break
                    case "truccabimbi": stringa.current += 'Truccabimbi, '; break
                    case "parcheggio": stringa.current += 'Parcheggio gratuito, '; break
                    case "navetta": stringa.current += 'Navetta, '; break
                    case "mercatini": stringa.current += 'Mercatini, '; break
                    case 'fiera': stringa.current += 'Fiera espositiva, '; break
                    case "standGastronomici": stringa.current += 'Stand Gastronomici, '; break
                    case "streetFood": stringa.current += 'Street Food, '; break
                    case "areaTavoli": stringa.current += 'Area tavoli, '; break
                    case "birraArtigianale": stringa.current += 'Birra artigianale, '; break
                    case "musica": stringa.current += 'Musica Live, '; break
                    case "djSet": stringa.current += 'Dj set, '; break
                    case "centroStorico": stringa.current += 'Centro storico visitabile, '; break
                    case "addobbi": stringa.current += 'Addobbi scenografici, '; break
                    case "attrazioniBambini": stringa.current += 'Attrazioni per bambini, '; break
                    case "liscio": stringa.current += 'Ballo liscio, '; break
                    case "gruppo": stringa.current += 'Balli di gruppo, '; break
                    case "scuolaDiBallo": stringa.current += 'Scuola ballo '; break
                    default:
                }
            })
        }
    }, [redux])
    useEffect(() => { console.log('redux:', redux) }, [redux])
    useEffect(() => { window.scrollTo(0, 0) }, [])
    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />
        }
        <div className='bodyPadding'>
            <h2 style={{ margin: '7rem 0 3rem 0', display: 'inline-block' }}>Riepilogo dell'evento</h2>
            <button className='btn btn-primary' style={{ marginLeft: '1em' }} onClick={create}>Avanti</button>

            {msgProgress.string &&
                <h5 style={{ margin: '0 0 1em 0' }}>
                    <RotatingLines strokeColor='navy' strokeWidth='5' animationDuration='5' width='26' />
                    <span style={{ marginLeft: '1rem', color: 'navy' }}>{msgProgress.string}</span>
                </h5>
            }
            {msgProgress.failed && <h5 style={{ color: 'red', marginTop: '1em' }}>{msgProgress.failed}</h5>}

            <div style={grid}>
                <div>Titolo:</div> <div>{redux.titolo}</div>
            </div>
            {redux.sottotitolo &&
                <div style={grid}>
                    <div>SottoTitolo:</div> <div style={{ border: '1px solid paleturquoise' }}>{redux.sottotitolo}</div>
                </div>
            }
            <div style={grid}>
                <div>Tipologia:</div> <div>{redux.tipologia}</div>
                <div>Regione:</div> <div>{redux.regione}</div>
                <div>Città:</div> <div>{redux.città}</div>
                <div>Location:</div> <div>{redux.comune}</div>
            </div>
            {redux.indirizzo &&
                <div style={grid}>
                    <div>Indicazioni:</div> <div>{redux.indirizzo}</div>
                </div>
            }
            <div style={grid}>
                <div>Provincia:</div> <div>{redux.provincia.toUpperCase()}</div>
                <div>Email:</div> <div>{redux.email}</div>
            </div>
            {redux.telefono && <div style={grid}>
                <div>Telefono:</div> <div>{redux.telefono}</div>
            </div>}

            <div style={grid}>
                <div>Inizio evento:</div> <div>{redux.dataInizio.split("-").reverse().join("-")}
                    {redux.oraInizio && <span> alle {redux.oraInizio}</span>}
                </div>
                <div>Fine evento:</div> <div>{redux.dataFine.split("-").reverse().join("-")}
                    {redux.oraFine && <span> alle {redux.oraFine}</span>}
                </div>
            </div>
            {redux.opzioniEvento.length !== 0 ?
                <div><hr />
                    <h5>OPZIONI EVENTO:</h5>
                    <div style={{ marginLeft: '5px' }}>{stringa.current}</div>
                </div> : null}<hr />
            {redux.biglietto ?
                <div style={grid}>
                    <div><h5>Biglietto:</h5></div> <div>€ {redux.prezzo}</div>
                    <div></div> <div><i>{redux.opzioniBiglietto}</i></div>
                </div> :
                redux.noBiglietto ? <p className='btn btn-success mt-3'>Ingresso gratuito</p> :
                    redux.sito ? <p className='btn btn-primary mt-3'>Biglietto: Vai al sito</p> :
                        null
            }

            <h6 className='mt-3'>DESCRIZIONE:</h6>
            <ReactQuill className="textarea-quill"
                value={redux.descrizione}
                theme="snow"
                modules={{
                    toolbar: false
                }}
            />
            <br />
            {redux.url !== '' &&
                <div style={grid}>
                    <div>URL sito web: </div> <div>{redux.url.substring(0, 30)}...</div>
                </div>
            }

            {ospiti.current.length !== 0 &&
                <div>
                    <div className='mt-3' style={grid}>
                        <div>OSPITI:</div>
                        <div style={{ marginLeft: '-60px' }}>
                            {ospiti.current.map((elem, index) => {
                                return (
                                    <span> {elem}
                                        {index + 1 !== ospiti.current.length && <span>,</span>}
                                    </span>
                                )
                            })
                            }
                        </div>
                    </div><hr />
                </div>
            }

            {redux.fb !== '' &&
                <div style={grid}>
                    <div>URL FB: </div> <div>{redux.fb.substring(0, 30)}...</div>
                </div>
            }
            {redux.youTube !== '' &&
                <div style={grid}>
                    <div>URL YouTube: </div> <div>{redux.youTube.substring(0, 30)}...</div>
                </div>
            }

            {redux.infoOrganizzatore &&
                <div className='mt-3'>
                    <h6>INFO ORGANIZZATORE:</h6>
                    <p><i>{redux.infoOrganizzatore}</i></p><hr />
                </div>
            }

            {redux.foto.length > 0 &&
                <div>
                    <p className='mt-5'>IMMAGINI CARICATE</p>
                    <div className='gridAddEvento2 mt-3'>
                        {redux.foto.map((elem, index) => (
                            <div key={index} style={{ textAlign: 'center' }}>
                                <img src={`https://leuro-bucket.s3.amazonaws.com/${elem}`} style={{ maxWidth: '100px', height: '74px' }} alt="" />
                            </div>
                        ))}
                    </div>
                    <hr />
                </div>
            }

            {redux.video &&
                <div>
                    <p className='mt-3'>VIDEO CARICATO:</p>
                    <video src={`https://leuro-bucket.s3.amazonaws.com/video/${redux.video}`} style={{ maxWidth: '144px', height: '80px' }} controls />
                </div>
            }

            {redux.pubblicitàFB === true ?
                <div className='mt-5'>▪ L'evento sarà condiviso su FB e ISTANGRAM alla pagina ZonaEventi</div> :
                <div className='mt-5'>▪ L'evento NON sarà condiviso su FB e ISTANGRAM alla pagina ZonaEventi</div>
            }

            {msgProgress.string &&
                <h5 className='mt-3'>
                    <RotatingLines strokeColor='navy' strokeWidth='5' animationDuration='5' width='26' />
                    <span style={{ marginLeft: '1rem', color: 'navy' }}>{msgProgress.string}</span>
                </h5>
            }

            {msgProgress.failed && <p style={{ color: 'red', marginTop: '1em' }}>{msgProgress.failed}</p>}
            <hr />
            <div className='mt-4'>
                <button type='button' className='btn btn-secondary'
                    onClick={() => {
                        navigate('/addEvento2', {
                            replace: true
                        })
                    }}>
                    Indietro
                </button>
                <button type='button' className='btn btn-primary' style={{ marginLeft: '4rem' }} onClick={create}>
                    Avanti
                </button>
            </div>
        </div>
        <DivBottom />
    </>)

}
export default ConfirmAddEvento